export const setAuthToken = async (user) => {
  const response = await fetch(
    `https://server-gs.vercel.app/user/${user.email}`,
    {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ email: user.email }),
    }
  );

  const data = await response.json();

  if (data?.token) {
    localStorage.setItem("aircnc-token", data.token);
    return data.token; // 👈 RETURN TOKEN
  }

  return null;
};



export const saveBooking = bookingData => {
  // Post method fetch
  return fetch(`https://server-gs.vercel.app/bookings`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${localStorage.getItem('aircnc-token')}`,
    },
    body: JSON.stringify(bookingData),
  })
}
